"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CategorySection;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _videoTileSection = _interopRequireDefault(require("./video-tile-section"));
var _searchResult = _interopRequireDefault(require("../../../navigation/header/site-search/search-result"));
var _searchBanner = _interopRequireDefault(require("../../../page-body/site-search-results/search-banner"));
var _index = _interopRequireDefault(require("../../../elements/other/actions/index"));
var _siteSearchContext = require("../site-search-context");
var _noResults = _interopRequireDefault(require("../no-results"));
var _serpSpin = _interopRequireDefault(require("../serp-results/serp-spin"));
var _resultButtons = require("../serp-results/result-buttons");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable max-statements */
/* eslint-disable complexity */

const CategorySectionContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CategorySectionContainer",
  class: "pl-c1tde3jj"
});
const SearchResultContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SearchResultContainer",
  class: "pl-sqbcus"
});
const Heading = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Heading",
  class: "pl-h1b3067a"
});
const TitleContainer = /*#__PURE__*/(0, _react2.styled)("h6")({
  name: "TitleContainer",
  class: "pl-tyjr7rp"
});
const VideoResultContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "VideoResultContainer",
  class: "pl-vlb5d6t"
});
const VideoTitleContainer = /*#__PURE__*/(0, _react2.styled)(TitleContainer)({
  name: "VideoTitleContainer",
  class: "pl-v16zfqv7"
});
const ViewMoreContainer = /*#__PURE__*/(0, _react2.styled)("a")({
  name: "ViewMoreContainer",
  class: "pl-v1a49qsk"
});
const ActionsWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ActionsWrapper",
  class: "pl-agcbm5f"
});
function ActionsContainer({
  ctas,
  trackingCustomProperties = {}
}) {
  ctas.forEach(cta => {
    cta.trackingCustomProperties = trackingCustomProperties;
  });
  return /*#__PURE__*/_react.default.createElement(ActionsWrapper, null, /*#__PURE__*/_react.default.createElement(_index.default, {
    actionsLayout: "button-set",
    ctas: ctas
  }));
}
/**
 * Category Section component.
 * @module CategorySection
 *
 * @param {Object} props React props
 * @param {String} props.title Category title
 * @param {String} props.viewMoreText View more text
 * @param {String} props.viewMoreName View more name for tracking purposes
 * @param {Array} props.results Array of child
 * @param {Array} props.videoResults Array of child with video data
 * @param {String} props.activeKey Current active key
 * @param {String} props.sectionKey Section key
 * @param {Array} props.ctas Array of CTAs
 * @param {Function} props.setSelectedFilter Set filtered section
 * @param {String} props.videoSectionTitle Video section title
 * @returns {React.ReactElement} CategorySection component
 * @public
 */
function CategorySection({
  title,
  viewMoreText,
  domainBanner,
  domainSerp,
  sectionKey,
  videoCTA,
  resultCTA,
  noResultsHeadline,
  videoSectionTitle,
  videoTagFallback
}) {
  const {
    activeFilter,
    setActiveFilter,
    results,
    searchValue,
    searchData,
    resultsExternalPaths,
    trackingCustomProperties,
    setCurrentDomainSearch,
    searchDataIsLoading
  } = (0, _react.useContext)(_siteSearchContext.SiteSearchContext);
  const isActive = activeFilter === sectionKey;
  const sectionTracking = {
    ...trackingCustomProperties,
    ...((activeFilter === 'all' || activeFilter === 'help') && {
      sitesearch_category: sectionKey
    })
  };
  const viewMoreTracking = _patternLibraryUtils.tracking.create('link_view_more', true, true, sectionTracking);
  (0, _react.useEffect)(() => {
    domainSerp && setCurrentDomainSearch(domainSerp);
  }, [domainSerp, setCurrentDomainSearch]);
  const {
    hasSpins,
    error
  } = searchData[searchValue] || {};
  if (sectionKey === 'domain' && !searchDataIsLoading && !(hasSpins || error)) {
    return null;
  }
  const videoResults = sectionKey === 'help' ? results?.howTo : null;
  for (const result in videoResults) {
    if (!result.videoTag) {
      videoResults[result].videoTag = videoTagFallback;
    }
  }
  let resultsToDisplay = null;
  for (const key in results) {
    if (key === sectionKey) {
      resultsToDisplay = isActive ? results[key] : results[key].slice(0, 3);
      break;
    }
  }
  if (!resultsToDisplay && sectionKey !== 'domain') {
    return /*#__PURE__*/_react.default.createElement(_noResults.default, {
      headline: noResultsHeadline
    });
  }

  // Add search value query to ResultCTAs for help section key
  let resultCTAwithSearchValue = null;
  if (sectionKey === 'help') {
    resultCTAwithSearchValue = {
      ...resultCTA,
      href: `${resultCTA?.href}?q=${searchValue}&types=Article&types=Video`
    };
  }

  // Add search value as path to ResultCTAs for resources section key
  if (sectionKey === 'resources') {
    resultCTAwithSearchValue = {
      ...resultCTA,
      href: `${resultCTA?.href}/search/${searchValue}`
    };
  }

  // Add search value as path to VideoCTA for help section key
  let videoCTAwithSearchValue = null;
  if (sectionKey === 'help') {
    videoCTAwithSearchValue = {
      ...videoCTA,
      href: `${videoCTA?.href}?q=${searchValue}&types=Article&types=Video`
    };
  }
  const resultTracking = {
    ...sectionTracking,
    sitesearch_term: (0, _patternLibraryUtils.applySnakeCase)(searchValue),
    sitesearch_results: resultsToDisplay?.map(({
      title: resultTitle
    }, ix) => (0, _patternLibraryUtils.applySnakeCase)(['result', ix, resultTitle].join('_'))).join('¬'),
    sitesearch_urls: resultsToDisplay?.map(({
      url
    }) => url).join('¬')
  };
  const videoResultsTracking = {
    ...sectionTracking,
    sitesearch_term: (0, _patternLibraryUtils.applySnakeCase)(searchValue),
    sitesearch_results: videoResults?.map(({
      title: resultTitle
    }, ix) => (0, _patternLibraryUtils.applySnakeCase)(['result', ix, resultTitle].join('_'))).join('¬'),
    sitesearch_urls: videoResults?.map(({
      url
    }) => url).join('¬')
  };
  videoResults?.forEach(result => {
    result.trackingCustomProperties = {
      ...videoResultsTracking,
      category: 'how_to'
    };
  });
  return /*#__PURE__*/_react.default.createElement(CategorySectionContainer, {
    "data-cy": "category-section"
  }, /*#__PURE__*/_react.default.createElement(Heading, null, /*#__PURE__*/_react.default.createElement(TitleContainer, null, title), viewMoreText && activeFilter !== sectionKey && (sectionKey !== 'domain' ? /*#__PURE__*/_react.default.createElement(ViewMoreContainer, (0, _extends2.default)({
    "data-cy": "view-more",
    tabIndex: "0",
    onClick: () => {
      (0, _patternLibraryUtils.scrollToTop)();
      setActiveFilter(sectionKey);
    }
  }, viewMoreTracking), viewMoreText) : /*#__PURE__*/_react.default.createElement(ViewMoreContainer, (0, _extends2.default)({
    "data-cy": "view-more-domains",
    tabIndex: "0",
    href: (0, _resultButtons.createHref)(searchValue)
  }, viewMoreTracking), viewMoreText))), resultsToDisplay && /*#__PURE__*/_react.default.createElement(SearchResultContainer, {
    "data-cy": "search-results-container"
  }, resultsToDisplay.map((result, i) => /*#__PURE__*/_react.default.createElement(_searchResult.default, (0, _extends2.default)({
    key: i,
    id: i
  }, result, {
    value: searchValue,
    resultsExternalPaths: resultsExternalPaths,
    trackingCustomProperties: resultTracking,
    titleSize: 2,
    step: "results"
  }))), isActive && resultCTA && /*#__PURE__*/_react.default.createElement(ActionsContainer, {
    ctas: [resultCTAwithSearchValue || resultCTA],
    trackingId: `${sectionKey}_results_cta`,
    trackingCustomProperties: sectionTracking
  })), videoResults?.length > 0 && /*#__PURE__*/_react.default.createElement(VideoResultContainer, null, isActive && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement(VideoTitleContainer, null, videoSectionTitle)), /*#__PURE__*/_react.default.createElement(_videoTileSection.default, {
    videoTileResults: videoResults
  }), isActive && videoCTA && /*#__PURE__*/_react.default.createElement(ActionsContainer, {
    ctas: [videoCTAwithSearchValue || videoCTA],
    trackingId: `${sectionKey}_video_cta`,
    trackingCustomProperties: {
      ...sectionTracking,
      category: 'how_to'
    }
  })), domainBanner && /*#__PURE__*/_react.default.createElement(_searchBanner.default, domainBanner), domainSerp && /*#__PURE__*/_react.default.createElement(_serpSpin.default, {
    searchQuery: searchValue
  }), /*#__PURE__*/_react.default.createElement("hr", null));
}
CategorySection.propTypes = {
  title: _propTypes.default.string,
  viewMoreText: _propTypes.default.string,
  viewMoreName: _propTypes.default.string,
  results: _propTypes.default.any,
  videoResults: _propTypes.default.any,
  domainBanner: _propTypes.default.any,
  domainSerp: _propTypes.default.any,
  activeKey: _propTypes.default.string,
  sectionKey: _propTypes.default.string,
  showHeading: _propTypes.default.bool,
  ctas: _propTypes.default.array,
  noResultsHeadline: _propTypes.default.string,
  videoSectionTitle: _propTypes.default.string,
  videoTagFallback: _propTypes.default.string,
  videoCTA: _propTypes.default.object,
  resultCTA: _propTypes.default.object
};
ActionsContainer.propTypes = {
  ctas: _propTypes.default.array,
  trackingId: _propTypes.default.string,
  trackingCustomProperties: _propTypes.default.object
};